import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import 'fontsource-roboto';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Switch, Route, Redirect} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';

import Dashboard from '../Views/Dashboard';
import Receptions from '../Views/Receptions';
import AddReception from '../Views/AddReception';
import ViewReception from '../Views/ViewReception';
import Patients from '../Views/Patients';
import Results from '../Views/Results';
import ResellerServices from '../Views/ResellerServices';
import Consumables from '../Views/Consumables';

import MedicalRecords from '../Views/MedicalRecords';

import ExternLabs from '../Views/ExternLabs';
import CovidLetters from '../Views/CovidLetters';

import Documents from '../Views/Documents';

import Partners from '../Views/Partners';
import Users from '../Views/Users';
import Permissions from '../Views/Permissions';
import Registers from '../Views/Registers';
import Services from '../Views/Services';
import Test from '../Views/Test';

import CnpDuplicates from '../Views/CnpDuplicates';

const useStyles = makeStyles(theme => ({
  main: {
    margin: theme.spacing(7, .5, 11, .5)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

export default function RouterView(props) {
  const classes = useStyles();
  const ajax = props.ajax;
  const user = props.user;

  const [item, setItem] = useState(null); // item to be deleted on server

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  const handleDelete = () => {
    ajax(item.op, {
      id: item.id
    })
      .then(response => {
        if (response.ok) {
          item.history.replace('/Reload');
          setTimeout(() => {
            item.history.replace(item.pathname);
            setItem(null);
          });
        }
      });
  };

  return (
    <Fragment>
      <div className={classes.main}>
        <Switch>
          <Route exact path='/' render={() => <Redirect to='/Dashboard' />}></Route>
          <Route exact path='/Reload'                     render={(routeProps) => null}></Route>
          <Route exact path='/Dashboard'                  render={(routeProps) => <Dashboard        {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Receptions'                 render={(routeProps) => <Receptions       {...props} {...routeProps} ajax={ajax} user={user} deleteItem={item => setItem(item)}           />}></Route>
          <Route exact path='/AddReception'               render={(routeProps) => <AddReception     {...props} {...routeProps} ajax={ajax} user={user} deleteItem={item => setItem(item)}           />}></Route>
          <Route exact path='/AddReception/:cnp'          render={(routeProps) => <AddReception     {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/ViewReception/:idReception' render={(routeProps) => <ViewReception    {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Reception/:idReception'     render={(routeProps) => <AddReception     {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Patients'                   render={(routeProps) => <Patients         {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Results'                    render={(routeProps) => <Results          {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Results/:cnp'               render={(routeProps) => <Results          {...props} {...routeProps} ajax={ajax} user={user}                                    dummy={0} />}></Route>
          <Route exact path='/ResellerServices'           render={(routeProps) => <ResellerServices {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Consumables'                render={(routeProps) => <Consumables      {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>

          <Route exact path='/MedicalRecords'             render={(routeProps) => <MedicalRecords   {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/MedicalRecords/:op'         render={(routeProps) => <MedicalRecords   {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>

          <Route exact path='/ExternLabs'                 render={(routeProps) => <ExternLabs       {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/CovidLetters'               render={(routeProps) => <CovidLetters     {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>

          <Route exact path='/Documents'                  render={(routeProps) => <Documents        {...props} {...routeProps}                                                                      />}></Route>

          <Route exact path='/Partners'                   render={(routeProps) => <Partners         {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Users'                      render={(routeProps) => <Users            {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Permissions'                render={(routeProps) => <Permissions      {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Registers'                  render={(routeProps) => <Registers        {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Services'                   render={(routeProps) => <Services         {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>
          <Route exact path='/Test'                       render={(routeProps) => <Test             {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>

          <Route exact path='/CnpDuplicates'              render={(routeProps) => <CnpDuplicates    {...props} {...routeProps} ajax={ajax} user={user}                                              />}></Route>

          <Route render={() => <Redirect to='/' />}></Route>
        </Switch>
      </div>

      {item &&
        <Dialog scroll='paper' TransitionComponent={Transition}
          fullScreen={fullScreen}
          open={item !== null}
          onClose={() => setItem(null)}
        >
          <DialogTitle>{item.title}</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>{item.question}</Typography></DialogContentText>
            <DialogContentText><Typography component='span'>{item.content}</Typography></DialogContentText>
            <DialogContentText>
              <Typography component='span'>Se va sterge: </Typography>
              <Typography component='span' color='secondary'>{item.item}</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus
              onClick={() => setItem(null)}
            >
              Anuleaza
            </Button>
            <Button color='secondary'
              onClick={handleDelete}
            >
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Fragment>
  );
}
RouterView.propTypes = {
  ajax: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
};
RouterView.defaultProps = {
  isLoading: false
};